import type { Transaction, TransactionsFetchResponse } from '@shared/transactions-types';
import { request } from '@luna/api';

import { getTransactionUrl } from '../TransactionsApiService';

type QueryByIdParams = { productId?: string };

export async function queryTransactionById(
    transactionId: string,
    { productId }: QueryByIdParams = {},
): Promise<Transaction> {
    const url = getTransactionUrl({ productId, transactionId });
    const { collection: [found] = [] } = await request<TransactionsFetchResponse>(url);
    return found;
}
